import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mes-achats',
  templateUrl: './mes-achats.component.html',
  styleUrls: ['./mes-achats.component.css'],
  standalone: false
})
export class MesAchatsComponent implements OnInit {
  achatslist: any[] = [];
  allAchats: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  sigle: string;

  constructor(private userService: PayService, private router: Router) {

  }

  ngOnInit(): void {
    this.getutilisateurAchats();
    this.sigle = localStorage.getItem('sigle');
  }

  getutilisateurAchats() {
    this.userService.getUtilisateurAchats().subscribe((data: any[]) => {
      this.allAchats = data || [];
      console.log(data);
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);
    })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.achatslist = this.allAchats.filter(a => this.getMonthKey(a?.date) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current);
    this.allAchats.forEach(a => {
      const key = this.getMonthKey(a?.date);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a))
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKey(dateInput: any): string {
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) { return ''; }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${d.getFullYear()}-${month}`;
  }

  private getCurrentMonthKey(): string {
    return this.getMonthKey(new Date());
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }

}
